<template>
    <div class="mt-2 pb-3 relative">
        <p class="is-size-7 p-1 has-text-greyText has-text-weight-medium">
            {{ userName }}
        </p>
        <div class="right-corner is-pointer" @click="openBigParticipant">
            <Icon
                family="fa"
                name="fa-expand-arrows-alt"
                helperClass="medium-icon"
            />
        </div>
        <div
            v-if="hasVideoOrAudio"
            ref="videoContainer"
            class="boxCamera is-radiusless"
        >
            <VideoPlaceholder v-if="!hasVideo" :name="userName" :small="true" />
            <BigParticipant
                v-if="showBigParticipant"
                :stream="localStream"
                :userName="userName"
                @close="closeBigParticipant"
            />
        </div>
    </div>
</template>

<script>
import VideoPlaceholder from "./VideoPlaceholder";
import BigParticipant from "./BigParticipant";

export default {
    name: "local-participant",
    components: {
        VideoPlaceholder,
        BigParticipant,
    },
    props: {
        participant: {
            type: Object,
            required: true,
        },
        tracks: {
            type: Array,
            required: true,
        },
        userName: {
            type: String,
            required: true,
        },
        mutedAudio: {
            type: Boolean,
            default: false,
        },
        mutedVideo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localStream: null,
            showBigParticipant: false,
        };
    },
    mounted() {
        this.initialiceCamera();
    },
    computed: {
        hasAudio() {
            return this.tracks?.find((t) => t.kind === "audio") !== undefined;
        },
        hasVideo() {
            return this.tracks?.find((t) => t.kind === "video") !== undefined;
        },
        hasVideoOrAudio() {
            return this.hasVideo || this.hasAudio;
        },
    },
    watch: {
        mutedAudio(muted) {
            if (muted) {
                this.muteAudio();
            } else {
                this.unmuteAudio();
            }
        },
        mutedVideo(muted) {
            if (muted) {
                this.muteVideo();
            } else {
                this.unmuteVideo();
            }
        },
    },
    methods: {
        initialiceCamera() {
            const div = document.createElement("div");
            div.id = new Date().getTime();
            window.console.log(this.tracks);
            this.tracks.forEach((track) => div.appendChild(track.attach()));
            this.$refs.videoContainer.appendChild(div);

            let video = this.$refs.videoContainer.querySelector("video");

            if (video) {
                this.localStream = video.captureStream();
            }
        },
        openBigParticipant() {
            this.showBigParticipant = true;
        },
        closeBigParticipant() {
            this.showBigParticipant = false;
        },
        muteAudio() {
            this.participant.audioTracks.forEach((t) => {
                t.track.disable();
            });
        },
        unmuteAudio() {
            this.participant.audioTracks.forEach((t) => {
                t.track.enable();
            });
        },
        muteVideo() {
            this.participant.videoTracks.forEach((t) => {
                t.track.disable();
            });
        },
        unmuteVideo() {
            this.participant.videoTracks.forEach((t) => {
                t.track.enable();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.boxCamera {
    width: 225px;
}
</style>